<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Base Asegurado</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
          <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Ejecutivos/Asistentes</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valEjecutivos"
                      v-model="datosFormulario.ejecutivo">
                  </b-form-select>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.ejecutivo }}</span>
              </b-col>
              </b-row>

              <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <!-- <b-form-group> -->
                <b-input-group> 
                    <b-form-input 
                        type="text" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                    <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                </b-input-group>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.poliza }}
                </span>     
                <!-- </b-form-group> -->
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Contratante</label>
              </b-col>
              <b-col sm="2">
                <b-form  @submit.prevent="consulta_contratante()" > 
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.contratante"
                  @change="validarCampo('contratante', 'contratante', $event, 'datosFormulario.contratante');consulta_contratante()"/>
                  <b-input-group-prepend class="input-group-append">
                      <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                  </b-input-group-prepend>
                </b-input-group>
                </b-form>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @submit.prevent="consulta_corredor()">
                    <b-form-input type="text" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button type="submit" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text" v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Ver</label>
              </b-col>
              <b-col sm="3">
                
              <b-form-checkbox-group
                  v-model="selectedDire"
                  :options="ckdDire"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>
              <b-col sm="1">
                <b-form-checkbox-group
                  v-model="selectedCor"
                  :options="ckdCorred"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>



          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Base Asegurado</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button v-if="hasPoliza" variant="primary" @click="nuevoContacto">Agregar Contacto</b-button>
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column
                  v-if="selectedCor.includes('C')"
                  prop="nomcorredor"
                  label="Corredor"
                  align="left"
                  width="200">
                </el-table-column>

                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="direlegal"
                  label="Dirección Legal"
                  align="left"
                  width="200">
                </el-table-column>
                          
                <el-table-column 
                  v-if="selectedDire.includes('DL')"
                  prop="paislegal"
                  label="País Legal"
                  align="left"
                  width="120">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="ciudlegal"
                  align="left"
                  label="Ciudad Legal"
                  width="120">
                </el-table-column>
                          
                <el-table-column
                  v-if="selectedDire.includes('DL')"
                  prop="comulegal"
                  label="Comuna Legal"
                  align="left"
                  width="120">
                </el-table-column>

                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="direpostal"
                  label="Dirección Postal"
                  align="left"
                  width="200">
                </el-table-column>
                
                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="ciudpostal"
                  align="left"
                  label="Ciudad Postal"
                  width="120">
                </el-table-column>
                
                <el-table-column
                  v-if="selectedDire.includes('DP')"
                  prop="comupostal"
                  label="Comuna Postal"
                  align="left"
                  width="120">
                </el-table-column>

                <el-table-column
                  prop="observaciones"
                  label="Observaciones"
                  align="left"
                  width="200"
                  type="text">
                </el-table-column>

                <el-table-column
                  prop="fmodif"
                  label="Última Modificación"
                  width="150"
                  align="center">
                </el-table-column>

                <el-table-column
                  prop="usuario"
                  label="Usuario"
                  align="left"
                  width="80">
                </el-table-column>

                <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>

              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      id="modificacion-contacto"
      title="Modificación Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"  
      @ok="handleOk"	
      @cancel="modalModificar = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcontratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Expirada</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.expirada">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ejecutivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.ejecutivo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Asistente</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.asistente">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.nombrecont">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Apellido Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.apellidocont">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Cargo Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="cargos"
                  v-model="datosFormularioModal.cargo">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>E-mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
            invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.email"
                   required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Fijo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 229999999"
                  title="Ingrese formato: 56 229999999"
                  v-model="datosFormularioModal.fijo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Móvil</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 999999999"
                  title="Ingrese formato: 56 999999999"
                  v-model="datosFormularioModal.celu">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Día a Día Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.diadiapol"
                value="SI"
                unchecked-value="NO">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Decisión Renovación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.decididor"
                value="SI"
                unchecked-value="NO">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.direlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>País Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="paises"
                  disabled
                  v-model="datosFormularioModal.paislegal">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.ciudlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.comulegal">
              </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.direpostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.ciudpostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.comupostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Observaciones</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.observaciones">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Última Modificación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.fmodif">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Usuario</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.usuario">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>
    
  <b-modal
      id="nuevo-contacto"
      title="Nuevo Contacto"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalNuevo"
      @ok="handleOk"
      @cancel="modalNuevo = false"
    >
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcontratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Expirada</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.expirada">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ejecutivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.ejecutivo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Asistente</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.asistente">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Nombre Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.nombrecont">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Apellido Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.apellidocont">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Cargo Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="cargos"
                  v-model="datosFormularioModal.cargo">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>E-mail Contacto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group
             invalid-feedback="La dirección de correo electrónico no incluye un signo @"
            :state="nameState">
              <b-form-input 
                  type="email" 
                  v-model="datosFormularioModal.email"
                  required
                  :state="nameState">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Fijo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 229999999"
                  title="Ingrese formato: 56 229999999"
                  v-model="datosFormularioModal.fijo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Teléfono Móvil</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  placeholder="56 999999999"
                  title="Ingrese formato: 56 999999999"
                  v-model="datosFormularioModal.celu">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Día a Día Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.diadiapol"
                value="SI"
                unchecked-value="NO">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Decisión Renovación</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-checkbox
                v-model="datosFormularioModal.decididor"
                value="SI"
                unchecked-value="NO">
              </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.direlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>País Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                  :options="paises"
                  disabled
                  v-model="datosFormularioModal.paislegal">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.ciudlegal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Legal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text"
                  disabled
                  v-model="datosFormularioModal.comulegal">
              </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Dirección Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.direpostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ciudad Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.ciudpostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comuna Postal</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.comupostal">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Observaciones</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  v-model="datosFormularioModal.observaciones">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    </b-modal>


    <!-- Eliminar -->
    <b-modal
      title="Eliminar Contacto"
      cancel-title="Cancelar"
      ok-title="Eliminar"
      class="modal-success"
      v-model="modalEliminar"
      @ok="eliminarGuardar();"
      @cancel="modalEliminar = false"
    >
        Se eliminara el siguiente contacto:
        <br><br>
        Asegurado: {{datosFormularioModal.nomcontratante}} 
        <br>
        Contacto: {{datosFormularioModal.nombrecont}} {{datosFormularioModal.apellidocont}}
    </b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseAsegurado from "@/components/services/apiBaseAsegurado";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "BaseAsegurado",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      nameState: null,
      submittedNames: [],
      modalModificar : false,
      modalEliminar : false,
      modalNuevo : false,
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      ckdDire: [
          { item:  'DL', name: 'Dirección Legal' },
          { item:  'DP', name: 'Dirección Postal' }
        ],
      ckdCorred: [
          { item: 'C', name: 'Corredor' }
        ],
      chkDireccion:false,

      data: [],
      nombreexcel: "BaseAsegurado",
      titles: [
        {
          prop: "nomcontratante",
          label: "Contratante",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        /*
        {
          prop: "nomcorredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        */
        {
          prop: "expirada",
          label: "E",
          align: "center",
          minwidth:'70'
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "asistente",
          label: "Asistente",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "nombrecont",
          label: "Nombre Contacto",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "apellidocont",
          label: "Apellido Contacto",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "cargo",
          label: "Cargo Contacto",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "email",
          label: "E-mail Contacto",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "fijo",
          label: "Teléfono fijo",
          align: "center",
          minwidth:'150'
        },
        {
          prop: "celu",
          label: "Teléfono Móvil",
          align: "center",
          minwidth:'150'
        },
        {
          prop: "diadiapol",
          label: "Día a Día Póliza",
          align: "center",
          minwidth:'150'
        },
        {
          prop: "decididor",
          label: "Decisión Renovación",
          align: "center",
          minwidth:'170'
        },
        /*
        {
          prop: "direlegal",
          label: "Dirección Legal",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "paislegal",
          label: "País Legal",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "ciudlegal",
          label: "Ciudad Legal",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "comulegal",
          label: "Comuna Legal",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "direpostal",
          label: "Dirección Postal",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "ciudpostal",
          label: "Ciudad Postal",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "comupostal",
          label: "Comuna Postal",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "observaciones",
          label: "Observaciones",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "fmodif",
          label: "Última Modificación",
          align: "center",
          minwidth:'150'
        },
        {
          prop: "usuario",
          label: "Usuario",
          align: "center",
          minwidth:'80'
        }*/
      ],
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              /*
              if (prop === 'fmodif'){
                let elDate = new Date(row["fmodif"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }*/
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          id: "",
          nomcontratante:"",
          poliza:"",
          producto:"",
          nomcorredor:"",
          expirada:"",
          ejecutivo:"",
          asistente:"",
          nombrecont:"",
          apellidocont:"",
          cargo:"",
          email:"",
          fijo:"",
          celu:"",
          diadiapol:"",
          decididor:"",
          direlegal:"",
          paislegal:"",
          ciudlegal:"",
          comulegal:"",
          direpostal:"",
          ciudpostal:"",
          comupostal:"",
          observaciones:"",
          fmodif:"",
          usuario:""
      },
      
      mostrarFechas: true,
      datosFormulario: {
          ejecutivo:"",
          poliza:"",
          producto:"",
          contratante:"",
          IdNacionAse :"",
          NombreAseg:"",
          codCorredor:"",
          IdNacionCorred:"",
          NombreCorred:"",
          vigente: "S",
          ejecutivopol:"",
          asistentepol:"",
          verDireccion:true,
          verCorredor:true,
          asegperdireccion:"", 
          asegperciudad:"",
          asegpercomuna:"",
          asegpernacion:"",
          asegperdirpostal:"", 
          asegperciupostal:"",
          asegpercompostal:""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      valEjecutivos: [],
      paises: [],
      ciudades: [],
      comunas: [],
      cargos: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {

    checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },

    resetModal() {
        this.name = ''
        this.nameState = null
      },

    handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault();  
        // Trigger submit handler
        this.handleSubmit();
      },

    handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return;
        }
        // Push the name to submitted names
        this.submittedNames.push(this.datosFormularioModal)
        // Hide the modal manually
        this.$nextTick(() => {
          this.saveRow(); 
          this.$bvModal.hide('nuevo-contacto');
          this.$bvModal.hide('modificacion-contacto');
        })
      },

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificarContacto(row);
          }
          botones.push(obj);
          
          var obj2 = new Object();
          obj2.tooltip = "Eliminar";
          obj2.id = 2;
          obj2.name="Eliminar";
          obj2.icon = "fa fa-eraser";
          obj2.type = "success";
          obj2.handler= _ => {
              this.$session.start();
              this.eliminarContacto(row);
          }
          botones.push(obj2);
          
          return botones;

    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ejecutivo ='0';
      this.datosFormulario.poliza = "";
      this.datosFormulario.producto="";
      this.datosFormulario.contratante ="";
      this.datosFormulario.IdNacionAse ="";
      this.datosFormulario.NombreAseg ="";
      this.datosFormulario.codCorredor ="";
      this.datosFormulario.NombreCorred ="";
      this.datosFormulario.IdNacionCorred ="";
      this.hasPoliza = false;

      return apiBaseAsegurado
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo ='0';
          this.datosFormulario.poliza='';
          this.datosFormulario.contratante='';
          this.datosFormulario.codCorredor='';

          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array(); 
          var objTodos = new Object();
          objTodos.value = "0";
          objTodos.text  = "Todos";
          tiposEjecutivos.push(objTodos); 

          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["ejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["ejecutivo"];
              tiposEjecutivos.push(obj);
          }

          this.valEjecutivos = tiposEjecutivos;
          
          //carga de listados
          this.paises = this.llenaArrayLista(response.data.pais, 'codigo', 'nombre', false);
          this.ciudades = this.llenaArrayLista(response.data.ciudad, 'codigo', 'nombre', false);
          this.comunas = this.llenaArrayLista(response.data.comuna, 'codigo', 'nombre', false);
          this.cargos = this.llenaArrayLista(response.data.cargo, 'codigo', 'nombre', false);

          this.datosFormularioEstado = response.data.festado;
          
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      this.datosFormulario.ejecutivo == 'Todos' ? '' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.contratante == '' ? '': this.datosFormulario.contratante; 
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_ejecutivo= this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;
      var p_contratante = this.datosFormulario.contratante == ''? '0' : this.datosFormulario.contratante;
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;

      return apiBaseAsegurado
      .recuperar(
        p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor
        ).then( (response)=>{

            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      
      ///COLUMNAS ESCRIBIR
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      //for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Contratante" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Poliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Producto" + "</td>\n";
        if (this.selectedCor.includes('C')){
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Corredor" + "</td>\n";
        }
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "E" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ejecutivo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Asistente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Apellido Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Cargo Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Mail Contacto" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Teléfono Fijo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Teléfono Móvil" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Día a Día Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Decisión Renovación" + "</td>\n";
        if (this.selectedDire.includes('DL')){
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Dirección Legal" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "País" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ciudad" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comuna" + "</td>\n";
        }
        if (this.selectedDire.includes('DP')){
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Dirección Postal" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ciudad" + "</td>\n";
          cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comuna" + "</td>\n";
        }
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Observación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Última Modificación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Usuario" + "</td>\n";
      //}
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      let diadiapol = '';
      let decididor = '';
      for (var key in this.data) {
        if(this.data[key]["nombrecont"] === undefined){ 
          this.data[key]["nombrecont"] = "";
        }
        if(this.data[key]["apellidocont"] === undefined){ 
          this.data[key]["apellidocont"] = "";
        }
        if(this.data[key]["email"] === undefined){ 
          this.data[key]["email"] = "";
        }
        if(this.data[key]["fijo"] === undefined){ 
          this.data[key]["fijo"] = "";
        }
        if(this.data[key]["celu"] === undefined){ 
          this.data[key]["celu"] = "";
        }
        
        if(this.data[key]["observaciones"] == undefined){ 
          this.data[key]["observaciones"] = "";
        }
        if(this.data[key]["usuario"] == undefined){ 
          this.data[key]["usuario"] = "";
        }
        if(this.data[key]["expirada"] == undefined){ 
          this.data[key]["expirada"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nomcontratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        if (this.selectedCor.includes('C')){
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nomcorredor"] + "</td>\n";
        }
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["expirada"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["nombrecont"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["apellidocont"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cargo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["email"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["fijo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["celu"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["diadiapol"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["decididor"] + "</td>\n";
        if (this.selectedDire.includes('DL')){
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["direlegal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["paislegal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ciudlegal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["comulegal"] + "</td>\n";
        }
        if (this.selectedDire.includes('DP')){
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["direpostal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ciudpostal"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["comupostal"] + "</td>\n";
        }
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["observaciones"] + "</td>\n";
         
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["fmodif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["usuario"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      this.datosFormulario.ejecutivo == 'Todos' ? '' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.contratante == '' ? '': this.datosFormulario.contratante; 
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_email= this.$session.get("mail");
      var p_ejecutivo= this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo==""){
          p_ejecutivo ='0';
      }

      return apiBaseAsegurado
        .consulta_poliza(
          p_email, p_ejecutivo, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
            this.datosFormulario.producto     = Listapoliza[i]["marproducto"];
            this.datosFormulario.NombreAseg   = Listapoliza[i]["nomcontratante"];
            this.datosFormulario.codCorredor  = Listapoliza[i]["marcorredor"];
            this.datosFormulario.NombreCorred = Listapoliza[i]["nomcorredor"];
            this.datosFormulario.vigente      = Listapoliza[i]["E"];
            this.datosFormulario.ejecutivopol = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.asistentepol   = Listapoliza[i]["asistente"]; 
            this.hasPoliza = true;
          }
          this.$Progress.finish();
          this.consulta_contratante();
          this.consulta_corredor();  
          this.buscar();  
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_contratante: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_contratante = this.datosFormulario.contratante == '' ? '0': this.datosFormulario.contratante; 
      var p_email = this.$session.get("mail");
      if ((p_contratante==0) || (p_contratante=="")){
          this.mensaje= "Ingrese SR Contratante";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseAsegurado
        .consulta_contratante(
          p_email, p_contratante
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.IdNacionAse = InfoContratante[i]["peridnacion"];
            this.datosFormulario.NombreAseg  = InfoContratante[i]["pernombreimp"];
            
            this.datosFormulario.asegperdireccion  = InfoContratante[i]["perdireccion"];
            this.datosFormulario.asegperciudad  = InfoContratante[i]["perciudad"];
            this.datosFormulario.asegpercomuna  = InfoContratante[i]["percomuna"];
            this.datosFormulario.asegpernacion  = InfoContratante[i]["pernacion"];
            this.datosFormulario.asegperdirpostal  = InfoContratante[i]["perdirpostal"];
            this.datosFormulario.asegperciupostal  = InfoContratante[i]["perciupostal"];
            this.datosFormulario.asegpercompostal  = InfoContratante[i]["percompostal"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseAsegurado
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["peridnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["pernombreimp"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    nuevoContacto: function(){
      this.datosFormularioModal.id = 0;
      this.datosFormularioModal.nomcontratante = this.datosFormulario.NombreAseg;
      this.datosFormularioModal.poliza = this.datosFormulario.poliza;
      this.datosFormularioModal.producto = this.datosFormulario.producto;
      this.datosFormularioModal.nomcorredor = this.datosFormulario.NombreCorred;
      this.datosFormularioModal.expirada = this.datosFormulario.vigente == '*'? '*' : '';
      this.datosFormularioModal.ejecutivo = this.datosFormulario.ejecutivopol;
      this.datosFormularioModal.asistente = this.datosFormulario.asistentepol;

      this.datosFormularioModal.nombrecont = "";
      this.datosFormularioModal.apellidocont = "";
      this.datosFormularioModal.cargo = "";
      this.datosFormularioModal.email = "";
      this.datosFormularioModal.fijo = "";
      this.datosFormularioModal.celu = "";
      this.datosFormularioModal.diadiapol = "NO";
      this.datosFormularioModal.decididor = "NO";

      this.datosFormularioModal.direlegal = this.datosFormulario.asegperdireccion;
      this.datosFormularioModal.paislegal = this.datosFormulario.asegpernacion;
      this.datosFormularioModal.ciudlegal = this.datosFormulario.asegperciudad;
      this.datosFormularioModal.comulegal = this.datosFormulario.asegpercomuna;
      this.datosFormularioModal.direpostal = this.datosFormulario.asegperdirpostal;
      this.datosFormularioModal.ciudpostal = this.datosFormulario.asegperciupostal;
      this.datosFormularioModal.comupostal = this.datosFormulario.asegpercompostal;
            
      this.datosFormularioModal.observaciones = "";
      this.datosFormularioModal.fmodif = "";
      this.datosFormularioModal.usuario = "";
      this.modalNuevo = true;
    },

    modificarContacto: function( row ){
      this.datosFormularioModal.id = row.id;
      this.datosFormularioModal.nomcontratante = row.nomcontratante;
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.producto = row.producto;
      this.datosFormularioModal.nomcorredor = row.nomcorredor;
      this.datosFormularioModal.expirada = row.expirada;
      this.datosFormularioModal.ejecutivo = row.ejecutivo;
      this.datosFormularioModal.asistente = row.asistente;
      this.datosFormularioModal.nombrecont = row.nombrecont;
      this.datosFormularioModal.apellidocont = row.apellidocont;
      this.datosFormularioModal.cargo = row.cargo;
      this.datosFormularioModal.email = row.email;
      this.datosFormularioModal.fijo = row.fijo;
      this.datosFormularioModal.celu = row.celu;
      this.datosFormularioModal.diadiapol = row.diadiapol;
      this.datosFormularioModal.decididor = row.decididor;
      this.datosFormularioModal.direlegal = row.direlegal;
      this.datosFormularioModal.paislegal = row.paislegal;
      this.datosFormularioModal.ciudlegal = row.ciudlegal;
      this.datosFormularioModal.comulegal = row.comulegal;
      this.datosFormularioModal.direpostal = row.direpostal;
      this.datosFormularioModal.ciudpostal = row.ciudpostal;
      this.datosFormularioModal.comupostal = row.comupostal;
      this.datosFormularioModal.observaciones = row.observaciones;
      this.datosFormularioModal.fmodif = row.fmodif;
      this.datosFormularioModal.usuario = row.usuario;
      this.modalModificar = true;
    },

    saveRow() { 
      let rows = this.datosFormularioModal;
      var p_id = rows.id;
      var vestado="";
      var vMensaje="";
      
      if ((parseInt(p_id)>0) && (this.modalModificar)){
        //Modificar
        return apiBaseAsegurado
          .editar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.poliza,
            rows.nombrecont,
            rows.apellidocont,
            rows.cargo,
            rows.email,
            rows.fijo,
            rows.celu,
            rows.paislegal, // rows.paislegal,
            rows.ciudpostal, // rows.ciudlegal,
            rows.comupostal, // rows.comulegal,
            rows.direpostal, // rows.direlegal,
            rows.decididor,
            rows.observaciones,
            rows.id,
            rows.diadiapol
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha editado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });        
      }else{
        return apiBaseAsegurado
          .insertar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            rows.poliza,
            rows.nombrecont,
            rows.apellidocont,
            rows.cargo,
            rows.email,
            rows.fijo,
            rows.celu,
            rows.paislegal,
            rows.ciudpostal,//ciudlegal
            rows.comupostal,//comulegal
            rows.direpostal,//direlegal
            rows.decididor,
            rows.observaciones,
            rows.diadiapol
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Insertar",
                "Se ha guardado el nuevo contacto.",
                "success"
              );
            }
            else{

              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
      }
    },
    
    eliminarContacto(row){
      this.datosFormularioModal.id = row.id;
      this.datosFormularioModal.nomcontratante = row.nomcontratante;
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.nombrecont = row.nombrecont;
      this.datosFormularioModal.apellidocont = row.apellidocont;
      this.modalEliminar = true;
    },

    eliminarGuardar(){
      return apiBaseAsegurado
          .eliminar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.id
          )
          .then((response) => {
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Eliminar",
                "Se ha eliminado el contacto.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });
    }
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
    //this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
